import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    navigate('/');
  };

  const buttonStyle = {
    backgroundColor: hovered ? '#2F80ED' : '#ffffff',
    color: hovered ? '#ffffff' : '#2F80ED',
    border: '1.5px solid #2F80ED',
    borderRadius: '20px',
    padding: '6px 16px',
    transition: 'all 0.2s ease-in-out',
  };

  return (
    <header
      className="px-3 py-2 border-bottom shadow-sm"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
        <img
          src="/logo.png"
          alt="Logo"
          style={{ height: '46px' }}
        />

        <button
          className="btn btn-sm"
          style={buttonStyle}
          onClick={handleLogout}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <i className="bi bi-box-arrow-right me-1"></i> Sair
        </button>
      </div>
    </header>
  );
};

export default Header;
